import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, } from 'react';
import {
  Container, CarrinhoTitulo, CarrinhoBody, CarrinhoBodyHeader, CarrinhoBodyItens,
  CarrinhoBodyImagemNomeProduto, CarrinhoBodyImagemNomeProdutoLinkImagem,
  CarrinhoBodyImagemNomeProdutoLinkNome,
  CarrinhoBodyItensValores, BtnRemoverProduto, CarrinhoDesktop
} from './styles';
import { formatarValores } from '../../helpers/valores';
import CarrinhoContext from '../../Context/Carrinho/CarrinhoContext';
import { AddProdutoCarrinho } from '../../Context/Carrinho/CarrinhoHandle';
import { async } from 'q';

const CarrinhoTeste: React.FC = () => {

  // const { totais } = useCalculaTotais();
  const { carrinhoReducer, dispatch } = useContext(CarrinhoContext);

  const AddProduto = async () => {
   const produto = await AddProdutoCarrinho({
      CodProduto: Date.now(),
      Src: "string",
      Titulo: "string",
      Vlr: 30,
      VlrFormatado: "string",
      CodAutor: "string",
      NomAutor: "string",
      CodEditora: 0,
      NomEditora: "string",
      Disponibilidade: "string",
      Qtd: 1,
      QuantidadeEmEstoque: 0,
      Desconto: 0,
      VlrDesconto: 0,
      VlrTotal: 30,
      VlrTotalFormatado: "string",
      Qtdestoque: 0,
      Codcarrinho: 0,
      Dscsituacaoestoque: "string",
      Inddestaque: 0,
      Indlancamento: 0,
      Indprevenda: 0,
      Pathimagem: "string",
      Datprevendafinal: "string",
      NroItem: 0,
    }, carrinhoReducer);
    dispatch({ type: "ADDPRODUTO", Produto: produto });

    }
  return (

    <Container isEmpty={false}>
      {/* {produtos.length === 0 && (
        <p>Seu carrinho está vazio!</p>
      )} */}

      {/* {produtos.length > 0 && ( */}
      <>
        <CarrinhoDesktop>
          <CarrinhoTitulo>
            Meu Carrinho
            <button onClick={() => AddProduto()}> Adicionar ao Carrinho</button>
            <p>{carrinhoReducer.QtdTotal}</p>
          </CarrinhoTitulo>

          <CarrinhoBody>
            <CarrinhoBodyHeader>
              <h3>Produto</h3>
              <h3>Valor Unitário</h3>
              <h3>Desconto</h3>
              <h3>Quantidade</h3>
              <h3>Estoque</h3>
              <h3>Encomenda</h3>
              <h3>Total</h3>
              <h3></h3>
            </CarrinhoBodyHeader>

            {carrinhoReducer.Produtos.map((produto) => (
              // produto.Qtd && produto.Qtd > 0 ?
              <CarrinhoBodyItens key={produto.CodProduto} color={produto.Qtd != null && produto.Qtd > produto.Qtdestoque ? 'red' : 'black'}>
                <CarrinhoBodyImagemNomeProduto>
                  <CarrinhoBodyImagemNomeProdutoLinkImagem>
                    {/* <img src={produto.Src} alt={produto.Titulo} /> */}
                    <div>
                      <a href={`/produtos/${produto.CodProduto}/detalhes`}>{<img src={produto.Src} />}</a>
                    </div>
                  </CarrinhoBodyImagemNomeProdutoLinkImagem>

                  <CarrinhoBodyImagemNomeProdutoLinkNome>
                    <a href={`/produtos/${produto.CodProduto}/detalhes`} className="produto-titulo">{produto.Titulo}</a>
                  </CarrinhoBodyImagemNomeProdutoLinkNome>
                </CarrinhoBodyImagemNomeProduto>

                <CarrinhoBodyItensValores>
                  {formatarValores(produto.Vlr)}
                </CarrinhoBodyItensValores>
                <CarrinhoBodyItensValores>
                  {`${produto.Desconto}%`}
                </CarrinhoBodyItensValores>

                {/* <CarrinhoBodyItensQuantidades>
                      <ProdutoQuantidade
                        aumentarQuantidade={() => currentlyCart.adicionaQuantidade(produto.CodProduto)}
                        diminuirQuantidade={() => produto.Qtd != null && produto.Qtd > 1 ? currentlyCart.removeQuantidade(produto.CodProduto) : null}
                        quantidade={produto.Qtd}
                        id={produto.CodProduto}>
                      </ProdutoQuantidade>
                    </CarrinhoBodyItensQuantidades> */}
                <CarrinhoBodyItensValores>
                  {produto.Qtdestoque > 0 ? produto.Qtdestoque : 0}

                </CarrinhoBodyItensValores>
                <CarrinhoBodyItensValores>
                  {produto.Qtd != null && produto.Qtd > produto.Qtdestoque ? produto.Qtd - produto.Qtdestoque : 0}
                </CarrinhoBodyItensValores>
                <CarrinhoBodyItensValores>
                  {formatarValores(produto.VlrTotal ?? 0)}
                </CarrinhoBodyItensValores>
                <BtnRemoverProduto>
                  <FontAwesomeIcon onClick={() => dispatch({ type: 'REMOVEPRODUTO', CodProduto: produto.CodProduto })} icon={faTrash} />
                </BtnRemoverProduto>
              </CarrinhoBodyItens>
              // : <p>Carrinho Vazio!</p>
            ))}

            {/* <Subtotal>
                <table>
                  <thead>
                    <th></th>
                    <th>Qtd</th>
                    <th>Valor</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Disponível: </td>
                      <th>{totais.qtdDisponivel}</th>
                      <td><b>{formatarValores(totais.vlrDisponivel)}</b></td>
                    </tr>
                    <tr>
                      <td>Encomenda: </td>
                      <th>{totais.qtdEncomenda}</th>
                      <td><b>{formatarValores(totais.vlrEncomenda)}</b></td>
                    </tr>
                    <tr>
                      <td>Total: </td>
                      <th>{totais.qtdTotal}</th>
                      <td><b>{formatarValores(totais.vlrTotal)}</b></td>
                    </tr>
                  </tbody>
                </table>
              </Subtotal> */}

          </CarrinhoBody>
          {/* <Frete/> */}

          {/* <CarrinhoFooter>
              <Botao onClick={() => handleLimparCarrinho()} containerStyle={{
                backgroundColor: "#fff", borderColor: "var(--botoesFiltrarFinalizar-bg-color)",
                color: "var(--botoesFiltrarFinalizar-bg-color)", borderWidth: 1, borderStyle: "solid",
                width: "20%"
              }}>
                Esvaziar Carrinho
              </Botao>
              <Botao onClick={() => currentlyCart.buscaCarrinho(currentlyCart.cart.CodCliente ? currentlyCart.cart.CodCliente : 0)} containerStyle={{
                backgroundColor: "#fff", borderColor: "var(--botoesFiltrarFinalizar-bg-color)",
                color: "var(--botoesFiltrarFinalizar-bg-color)", borderWidth: 1, borderStyle: "solid",
                width: "20%"
              }}><span className="limparCarrinho">Recarregar Carrinho</span></Botao>

              <Botao onClick={FinalizarPedido} containerStyle={{
                backgroundColor: "var(--botoesFiltrarFinalizar-bg-color)", borderColor: "var(--botoesFiltrarFinalizar-bg-color)",
                color: "#fff", borderWidth: 1, borderStyle: "solid",
                width: "20%"
              }}>
                Finalizar Pedido
              </Botao>

            </CarrinhoFooter> */}

        </CarrinhoDesktop>

      </>
      {/* )
      } */}
    </Container >);
}

export default CarrinhoTeste;
